import Promise from 'bluebird';
import { queryString } from 'lib/format';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import toAbsoluteURL from 'lib/url-adapter/toAbsoluteURL';
import { sanitizeQueryString } from 'lib/format/sanitizeQuery';
import { Api, Device } from 'enums';
import { searchApi as SearchAPIConfig } from '../../../config';

const DEFAULT_TIMEOUT = 10000;
const { Env: ApiEnv } = Api;

export const ERROR_PAGE_RESPONSE = {
    page : {
        name: 'Search API Error',
        buckets: []
    }
};
const ENVIRONMENT_CONFIGURATION = {
    dev: {
        serviceUrl: '//watch-search.espnsb.com'
    },
    qa: {
        serviceUrl: '//watch-search.espnqa.com'
    },
    staging: {
        serviceUrl: '//watch-search.espnqa.com'
    },
    prod: {
        serviceUrl: '//watch-search.espn.com'
    }
};

export const DEFAULT_CONFIGURATION = {
    serviceUrl : ENVIRONMENT_CONFIGURATION.qa.serviceUrl,
    paths: {
        base: '/api/product/v3/watchespn/web/',
        search: '/api/product/v3/watchespn/web/search',
        suggest: '/api/product/v3/watchespn/web/suggest',
        keyword: {
            base: '/api/product/v3/watchespn/web/keywords',
            listings: '/listings'
        }
    }
};

const config = { ...DEFAULT_CONFIGURATION, ...SearchAPIConfig };

const getServiceUrl = (env = ApiEnv.PROD) => {
    if (process.browser) {
        const browserEnvironment = env; //global.watchGlobals && global.watchGlobals.env;
        return ENVIRONMENT_CONFIGURATION[browserEnvironment || env].serviceUrl;

    }
    return toAbsoluteURL(ENVIRONMENT_CONFIGURATION[env].serviceUrl);
};

export function getSuggestion(query = '', apiEnv, {
    authNetworks,
    countryCode,
    deviceType = Device.DESKTOP,
    zipcode,
    lang,
    tz
} = {}) {
    if (query.length === 0) {
        return Promise.reject(new Error('No query to get a suggestion.'));
    }
    const sanitizedQuery = sanitizeQueryString(query);
    if (!sanitizedQuery) {
        return Promise.reject(new Error('No Valid Query Entered'));
    }
    const qs = queryString({
        q: sanitizedQuery,
        size: 3,
        authNetworks,
        countryCode,
        deviceType,
        zipcode,
        lang,
        tz,
        includeDtcContent: true
    });
    const url = `${getServiceUrl(apiEnv)}${config.paths.suggest}${qs}`;

    return request.get(url)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        }, (err) => {
            if (err.status === 404) {
                return ERROR_PAGE_RESPONSE;
            }
            return fallback.get(url);
        });
}

export function getSearchResults(query = '', apiEnv, {
    authNetworks,
    countryCode,
    deviceType = Device.DESKTOP,
    zipcode,
    lang,
    tz
} = {}) {
    if (query.length === 0) {
        return Promise.reject(new Error('No params to get a search result.'));
    }

    const sanitizedQuery = sanitizeQueryString(query);
    if (!sanitizedQuery) {
        return Promise.reject(new Error('No Valid Query Entered'));
    }
    const qs = queryString({
        q: sanitizedQuery,
        size: 50,
        authNetworks,
        countryCode,
        deviceType,
        zipcode,
        lang,
        tz,
        includeDtcContent: true
    });
    const url = `${getServiceUrl(apiEnv)}${config.paths.search}${qs}`;

    return request.get(url)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        }, (err) => {
            if (err.status === 404) {
                return ERROR_PAGE_RESPONSE;
            }
            return fallback.get(url);
        });
}

export function getAllCompetitors(apiEnv) {
    const url = `${getServiceUrl(apiEnv)}${config.paths.keyword.base}`;
    return request.get(url)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        }, (err) => {
            if (err.status === 404) {
                return [];
            }
            return fallback.get(url);
        });
}


export function getEventsForTeam(team, apiEnv, { size, includes, sortBy, sortOrder } = {}) {
    const qs = queryString({
        size,
        includes,
        sortBy,
        sortOrder
    });
    const url = `${getServiceUrl(apiEnv)}${config.paths.keyword.base}/${encodeURIComponent(team)}/listings${qs}`;
    return request.get(url)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        }, (err) => {
            if (err.status === 404) {
                return ERROR_PAGE_RESPONSE;
            }
            return fallback.get(url);
        });
}



// WEBPACK FOOTER //
// ./app/lib/api/SearchAPI.js